import { css, Interpolation, Theme } from '@emotion/react'
import { typographyClasses, checkboxClasses } from '@mui/material'

export const checkbox: Interpolation<Theme> = (theme) => css`
  margin-left: 0;

  .${typographyClasses.root} {
    margin-left: ${theme.spacing(1.25)};

    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${theme.colors.gray};

    user-select: none;
  }

  .${checkboxClasses.disabled} {
    color: ${theme.colors.typographyFour};
  }
`
